import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import WhitelabelIcon from '~/icons/components/WhitelabelIcon';
import { MIN_REVIEW_COUNT } from '~/shared/constants/reviews';
import {
  mobile,
  useProductDetailContext,
  useReviewsDrawer,
} from '~/techstyle-shared/react-components';
import { useReviewsMetaDataQuery } from '~/techstyle-shared/react-products';

import scrollToRef from '../../utils/scrollToRef';
import BaseProductRating from '../ProductRating';

const ProductRating = styled(BaseProductRating)`
  align-items: flex-end;
  display: flex;

  ${mobile`
    margin-top: 0;
  `}
`;

function ProductRatingContainer({ productRef, reviewSectionRef }) {
  const { product, isBundle } = useProductDetailContext();
  const { openReviewsDrawer } = useReviewsDrawer();
  const { data: reviewsMetaData } = useReviewsMetaDataQuery(
    { groupCode: product.groupCode },
    { skip: !product.groupCode }
  );

  const linkReviews = !!(
    reviewsMetaData?.reviewsMetaData?.counts?.filteredCount > MIN_REVIEW_COUNT
  );

  const productRatingClickHandler = useCallback(
    (event) => {
      event.preventDefault();
      if (isBundle) {
        scrollToRef(productRef, { block: 'start' });
        return;
      }

      if (linkReviews) {
        openReviewsDrawer(product);
      } else {
        scrollToRef(reviewSectionRef);
      }
    },
    [
      isBundle,
      openReviewsDrawer,
      product,
      productRef,
      reviewSectionRef,
      linkReviews,
    ]
  );

  if (!reviewsMetaData?.reviewsMetaData) {
    return null;
  }

  return (
    <ProductRating
      onProductRatingClick={productRatingClickHandler}
      emptyIcon={<WhitelabelIcon iconName="emptyStar" />}
      fullIcon={<WhitelabelIcon iconName="filledStar" />}
      shouldPreventLinking={!linkReviews}
    />
  );
}

ProductRatingContainer.propTypes = {
  productRef: PropTypes.any,
  reviewSectionRef: PropTypes.any,
};

export default ProductRatingContainer;
